import Plugin, { init } from "@/modules/_utils/Plugin";
import OverlayScrollbars from "overlayscrollbars";

class CartStepComplete extends Plugin {
  init() {
    OverlayScrollbars(document.querySelectorAll(".scrollbar"), {});
  }
}

export default init(CartStepComplete, "CartStepComplete");
